import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { auth } from "./firebaseConfig";
import { signOut } from "firebase/auth";
import "./Navbar.css";

const Navbar = () => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const handleLogout = async () => {
    await signOut(auth);
    navigate("/login");
  };

  return (
    <nav className="navbar">
      <h3 className="logo" onClick={() => navigate("/dashboard")}>EduQuiz Hub</h3>
      <div className={`nav-links ${open ? "open" : ""}`}>
        <button onClick={() => navigate("/dashboard")}>Dashboard</button>
        <button onClick={() => navigate("/browse-quizzes")}>Browse</button>
        <button onClick={() => navigate("/create-quiz")}>Create Quiz</button>
        <button onClick={handleLogout}>Logout</button>
      </div>
      <div className="hamburger" onClick={() => setOpen(!open)}>
        ☰
      </div>
    </nav>
  );
};

export default Navbar;
